export class ItemBarcodeRequest{
    unitId:number;
    itemBarcode:number;
    constructor(unitId:number,
        itemBarcode:number){
            this.itemBarcode = itemBarcode
            this.unitId = unitId
    }
}